let inches = document.querySelectorAll('.td_inches')
    let cm = document.querySelectorAll('.td_cm')
    const handleChange=(src)=>{
      let target = src.value;
      if(target == 'cm'){
        cm.forEach(td => {
          td.classList.add('td_active')
          td.classList.remove('td_inactive')
          
        });
        inches.forEach(td => {
          td.classList.add('td_inactive')
          td.classList.remove('td_active')
        });
      }
      else if(target == 'inches'){
        inches.forEach(td => {
          td.classList.add('td_active')
          td.classList.remove('td_inactive')
          
        });
        cm.forEach(td => {
          td.classList.add('td_inactive')
          td.classList.remove('td_active')
        });
      }
    }
    let select = document.getElementById('measurement_units_selectId')
    
   /* select.addEventListener('change',function(e){
      let target = e.target.value;
      if(target == 'cm'){
        cm.forEach(td => {
          td.classList.add('td_active')
          td.classList.remove('td_inactive')
          
        });
        inches.forEach(td => {
          td.classList.add('td_inactive')
          td.classList.remove('td_active')
        });
      }
      else if(target == 'inches'){
        inches.forEach(td => {
          td.classList.add('td_active')
          td.classList.remove('td_inactive')
          
        });
        cm.forEach(td => {
          td.classList.add('td_inactive')
          td.classList.remove('td_active')
        });
      }
    })*/